import { Separator as TextSeparator } from "@empglabs/backoffice-ui-kit"

const Separator = props => {
  return <TextSeparator {...props} />
}

export default Separator
